export const LogTypes = {
  REQUEST: 'Request',
  RESPONSE: 'Response',
  PUBLISH: 'Publish',
  CONSUME: 'Consume'
};
